var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-16"},_vm._l((3),function(row_index){return _c('div',{key:row_index},[_c('v-skeleton-loader',{staticClass:"mb-8",attrs:{"type":"image","height":"72px"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }